import { Link } from 'react-router-dom';
import { MagnifyingGlassIcon, Cog6ToothIcon, QuestionMarkCircleIcon, WrenchScrewdriverIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';
import UserProfile from './UserProfile';

const Header = () => {
  const { isAdmin } = useAuth();

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="flex items-center">
              {/* Logo Icon */}
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <svg width="20" height="20" viewBox="0 0 40 40" fill="none">
                  <path d="M8 30L16 20L24 25L32 15L40 20V35H8V30Z" fill="white"/>
                  <circle cx="12" cy="25" r="1.5" fill="#60a5fa"/>
                  <circle cx="18" cy="21" r="1.5" fill="#60a5fa"/>
                  <circle cx="24" cy="23" r="1.5" fill="#60a5fa"/>
                  <circle cx="30" cy="15" r="1.5" fill="#60a5fa"/>
                  <circle cx="36" cy="20" r="1.5" fill="#60a5fa"/>
                </svg>
              </div>
              <span className="ml-2 text-xl font-bold text-gray-900">ProductTrace</span>
            </div>
          </Link>

          {/* Navigation */}
          <div className="flex items-center space-x-4">
            <button className="p-2 text-gray-400 hover:text-gray-600 transition-colors">
              <MagnifyingGlassIcon className="w-5 h-5" />
            </button>
            
            {/* Admin-only links */}
            {isAdmin && (
              <>
                <Link 
                  to="/admin" 
                  className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
                  title="Admin Dashboard"
                >
                  <WrenchScrewdriverIcon className="w-5 h-5" />
                </Link>
                <Link 
                  to="/admin/feedback" 
                  className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
                  title="Feedback Management"
                >
                  <ChatBubbleLeftRightIcon className="w-5 h-5" />
                </Link>
              </>
            )}
            
            <button className="p-2 text-gray-400 hover:text-gray-600 transition-colors">
              <Cog6ToothIcon className="w-5 h-5" />
            </button>
            <button className="p-2 text-gray-400 hover:text-gray-600 transition-colors">
              <QuestionMarkCircleIcon className="w-5 h-5" />
            </button>
            
            {/* User Profile */}
            <UserProfile />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 